import { useStore } from "@tanstack/react-form";
import { useEffect, useState } from "react";
import type { OverviewForm } from "./useOverview.ts";
import { postMessageToIframeParent } from "../utills/iframeMessaging.ts";

export const useHomeFilter = (overviewForm: OverviewForm) => {
	const filter = useStore(overviewForm.store, (select) => select.values);
	const [parsedFilter, setParsedFilter] = useState(filter);
	const stringifiedFilter = encodeURIComponent(JSON.stringify(filter));

	const parseFilter = (uri: string) => {
		return JSON.parse(decodeURIComponent(uri).substring(1));
	};

  // form has at least one frame of latency so we have to ... maybe some even listener???
  const [userJustDidManualSearch,setUserJustDidManualSearch] = useState(false);
	const manualSearch = () => {
    setUserJustDidManualSearch(true);
	};

	useEffect(() => {
		const controller = new AbortController();

		window.addEventListener(
			"message",
			(e) => {
				if (e.data.type === "homeFilter") {
          // console.log("%chomeFilter -> setting state","#f0f",parseFilter(e.data.hash));
					setParsedFilter(parseFilter(e.data.hash));
				}
			},
			{ signal: controller.signal },
		);

		return () => controller.abort();
	}, []);

  // when form was updated (like on submit)
  useEffect(() => {
    if(userJustDidManualSearch) { // submitted or clicked on map ...
      setUserJustDidManualSearch(false);
    }

    // call iframe -> which will call us to re-render filter
    // console.log("%cfilter changed -> posting state", "#f0f", decodeURIComponent(stringifiedFilter));
    postMessageToIframeParent({type: "search", search: stringifiedFilter});
  }, [userJustDidManualSearch, filter]);

	return {
		parsedFilter,
    manualSearch,
	};
};